import React from 'react';

export interface IAddedToCartConfirmationModal {
  vendorVariant: any;
  quantity?: number;
}

export interface IAddedToCartConfirmationModalContext {
  open: (state: IAddedToCartConfirmationModal) => void;
}

/* istanbul ignore next */
// eslint-disable-next-line max-len
const AddedToCartConfirmationModalContext = React.createContext<IAddedToCartConfirmationModalContext>({
  open: () => null,
});

export default AddedToCartConfirmationModalContext;
